import { defineMessages } from "react-intl";

import {
	everCovidDiseaseMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/covid/covidDisease";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	covidDisease: {
		id: "ktx.form.covid_disease.title",
		defaultMessage: "COVID betegség"
	},
	everCovidDisease: {
		id: "ktx.form.covid_disease.ever_covid_disease",
		defaultMessage: "Páciens COVID betegségen átesett?"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["everCovidDisease"],
						label: messages.everCovidDisease,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: everCovidDiseaseMessages
							}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_covidDisease",
	value: {
		schemaId: "covidDisease",
		title: messages.covidDisease,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
